import { ExternalLink } from 'lucide-react';

/** Из ссылки на публикацию достаём тип и shortcode: /reel/X/, /p/X/, /tv/X/. */
function parsePermalink(url: string): { kind: string; code: string } | null {
  const match = url.match(/instagram\.com\/(reels?|p|tv)\/([A-Za-z0-9_-]+)/i);
  if (!match) return null;
  const kind = match[1].toLowerCase().startsWith('reel') ? 'reel' : match[1].toLowerCase();
  return { kind, code: match[2] };
}

interface PermalinkCellProps {
  url: string;
  /** Подпись слева от кода — например @аккаунт, если он известен. */
  prefix?: string;
}

/**
 * Компактная ссылка на публикацию: полный URL занимает полтаблицы и всюду
 * одинаков до самого кода, поэтому показываем «reel · Dct5bv0yRrN».
 * Целиком адрес остаётся в подсказке и в самой ссылке.
 */
export function PermalinkCell({ url, prefix }: PermalinkCellProps): JSX.Element {
  const parsed = parsePermalink(url);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={url}
      className="group inline-flex max-w-[220px] items-center gap-1.5 text-primary hover:underline"
    >
      {prefix && <span className="shrink-0 text-muted-foreground">{prefix}</span>}
      <span className="truncate font-mono text-xs">
        {parsed ? (
          <>
            <span className="text-muted-foreground">{parsed.kind} · </span>
            {parsed.code}
          </>
        ) : (
          url.replace(/^https?:\/\/(www\.)?/, '')
        )}
      </span>
      <ExternalLink className="size-3 shrink-0 opacity-0 transition-opacity group-hover:opacity-70" />
    </a>
  );
}
